export const TYPE_CLOSE = 'TYPE_CLOSE';
export const TYPE_SHOW = 'TYPE_SHOW';
